import createClient from '../../helpers/api-client';

const storeSuffix = 'forgottenPassword';

//Actions
export const SEND_PASSWORD = `sendPasswordAction${storeSuffix}`;

//Mutations
export const BEGIN_SEND_PASSWORD = `beginSendPasswordMutation${storeSuffix}`;
export const PASSWORD_SENT = `finishSendPasswordAction${storeSuffix}`;
export const PASSWORD_NOT_SENT = `passwordNotSentAction${storeSuffix}`;

//Getters
export const GET_ERROR = `getErrorGetters${storeSuffix}`;

//state
export const modelState = () => ({
    sendPassword: {
        error: null,
    },
});

export const actions = {
    [SEND_PASSWORD]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SEND_PASSWORD);

            try {
                const res = await apiClient.post(
                    '/api/forgotten-password',
                    data
                );
                commit(PASSWORD_SENT);

                resolve(res);
            } catch (error) {
                let errorMessage =
                    'Ett fel har inträffat. Var vänlig försök igen.';
                commit(PASSWORD_NOT_SENT, errorMessage);
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_SEND_PASSWORD]: state => {
        state.sendPassword.error = null;
    },
    [PASSWORD_SENT]: state => {
        state.sendPassword.error = null;
    },
    [PASSWORD_NOT_SENT]: (state, payload) => {
        state.sendPassword.error = payload;
    },
};

export const getters = {
    [GET_ERROR]: state => {
        return state.sendPassword.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/forgotten-password-model.js